import loadable from "@loadable/component";
import { inject } from "mobx-react";
import { useParams } from "react-router";

import type { PageBlockInterface } from "../../page-blocks/Block.component";
import type { WeatherForecast } from "../../services/Weather";
import { Container } from "../../ui";
import classnames from "classnames";
import type { Store } from "@inferno/renderer-shared-core";

const TrafficTile = loadable(() => import("./TrafficTile.component"));
const WeatherTile = loadable(() => import("./WeatherTile.component"));

interface WeatherTileLoaderProps extends PageBlockInterface {
  params?: ReturnType<typeof useParams>;
  store?: Store;
}

export const WeatherTileLoader = inject("store")(({ params = {}, store, block }: WeatherTileLoaderProps) => {
  if (!store) {
    return null;
  }

  const { site } = store;
  // Traffic still needs coordinates to center its map; weather data now arrives on the block.
  const lat = params.geo_latitude || site.sections.general?.geo_latitude || null;
  const lon = params.geo_longitude || site.sections.general?.geo_longitude || null;

  const { tags } = block;
  const css = classnames("component-weather-tile", {
    [`themed-block`]: tags?.includes("display-hints/themed-block"),
  });

  const traffic = lat && lon ? <TrafficTile block={block} /> : null;

  // WeatherBug daily forecast arrives on the block from WebAPI (IHRWEB-23972); no client-side fetch.
  const forecast = (block as { forecast?: WeatherForecast }).forecast;
  const days = forecast && forecast.__typename === "SitesWeatherDailyForecastList" ? forecast.days : null;

  if (!days || !days.length) {
    return traffic;
  }

  return (
    <Container className={css}>
      <div className="weather-traffic-tile">
        <WeatherTile block={block} forecast={days} />
        {traffic}
      </div>
    </Container>
  );
});
export default WeatherTileLoader;
